import ExamModal from "@/models/Exam";

const GET_EXAM_PAGE_LIST = 'GET_EXAM_PAGE_LIST';
const GET_EXAM_HOME = 'GET_EXAM_HOME';
const GET_EXAM_RESULT = 'GET_EXAM_RESULT';
const EXAM_PREVIEW_DETAIL = 'EXAM_PREVIEW_DETAIL'
const GET_EXAM_START = 'GET_EXAM_START'
const SUBMIT_EXAM_OPTION = 'SUBMIT_EXAM_OPTION'
const SUBMIT_EXAM = 'SUBMIT_EXAM'
const CHECK_EXAM_STATUS = 'CHECK_EXAM_STATUS'

/**
 * 获取考试列表(分页)
 */
async function getExamPageList(params) {
  const payload = await new ExamModal().getExamPageList(params);
  return {
    type: GET_EXAM_PAGE_LIST,
    payload
  }
}

/**
 * 获取考试详情页
 */
async function getExamHome(params) {
  const payload = await new ExamModal().getExamHome(params);
  return {
    type: GET_EXAM_HOME,
    payload
  }
}

/**
 * 获取考试结果答案解析
 */
async function getExamResult(params) {
  const payload = await new ExamModal().getExamResult(params);
  return {
    type: GET_EXAM_RESULT,
    payload
  }
}

/**
 * 获取考试预览题目
 */
async function examPreviewDetail(params) {
  const payload = await new ExamModal().examPreviewDetail(params);
  return {
    type: EXAM_PREVIEW_DETAIL,
    payload
  }
}

/**
 * 获取开始考试题目
 */
async function getExamStart(params) {
  const payload = await new ExamModal().getExamStart(params);
  return {
    type: GET_EXAM_START,
    payload
  }
}

/**
 * 提交试卷(单题)
 */
async function submitExamOption(params) {
  const payload = await new ExamModal().submitExamOption(params);
  return {
    type: SUBMIT_EXAM_OPTION,
    payload
  }
}

/**
 * 提交试卷(整卷)
 */
async function submitExam(params) {
  const payload = await new ExamModal().submitExam(params);
  return {
    type: SUBMIT_EXAM,
    payload
  }
}

/**
 * 校验是否能答题
 */
async function checkExamStatus(params) {
  const payload = await new ExamModal().checkExamStatus(params);
  return {
    type: CHECK_EXAM_STATUS,
    payload
  }
}


const ACTION_TYPES = {
  GET_EXAM_PAGE_LIST,
  GET_EXAM_HOME,
  GET_EXAM_RESULT,
  EXAM_PREVIEW_DETAIL,
  GET_EXAM_START,
  SUBMIT_EXAM_OPTION,
  SUBMIT_EXAM,
  CHECK_EXAM_STATUS,
};

const ACTION = {
  getExamPageList,
  getExamHome,
  getExamResult,
  examPreviewDetail,
  getExamStart,
  submitExamOption,
  submitExam,
  checkExamStatus,
};

const ExamList = {
  ACTION_TYPES,
  ACTION
}

export default ExamList;